<ion-app>
  @if (isMaintenanceMode()) {
    <div class="maintenance-mode-overlay">
      <div class="maintenance-mode-content">
        <h1>Mantenimiento</h1>
        <p>La plataforma está en mantenimiento. Por favor, inténtalo de nuevo más tarde.</p>
      </div>
    </div>
  }
  @if (isDashboardRoute() !== null) {
    @if (isDocumentPreviewRoute()) {
      <div class="ion-page" id="main">
        <router-outlet></router-outlet>
      </div>
    } @else if (isDashboardRoute()) {
      <ion-split-pane when="lg" contentId="main" class="dashboard-split-pane" [class.minimize]="minimize()">
        <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
        <div class="ion-page" id="main">
          <div class="navbar-header">
            <a class="logo" routerLink="/dashboard">
              <img src="assets/menu-logo-light.svg" alt="Logo opero" class="menu-img">
            </a>
            <div class="hamburger-icon" (click)="toggleMenu()" (keyup.enter)="toggleMenu()" (keyup.space)="toggleMenu()" tabindex="0" role="button" aria-label="Ícono menú"></div>
          </div>
          <div class="outlet-wrapper">
            <router-outlet></router-outlet>
          </div>
        </div>
      </ion-split-pane>
    } @else {
      <div class="login-header">
        <div class="login-toolbar">
          <a class="menu-logo" routerLink="/dashboard">
            <img src="assets/menu-logo-light.svg" alt="Logo opero" class="menu-img">
          </a>
        </div>
      </div>
      <router-outlet></router-outlet>
    }
  }
  <app-toast />
  @for (sidePanel of sidePanels(); track sidePanel.id) {
    <app-side-panel-wrapper [sidePanel]="sidePanel" />
  }
  @for (modal of modals(); track modal.id) {
    <app-modal-wrapper [modal]="modal" />
  }
</ion-app>
<ng-template #menuTemplate>
  <ion-menu [side]="menuSide()" menuId="menu" contentId="main">
    <ion-content>
      <div class="menu-container">
        <div class="top-group">
          <div class="logo-and-close-icon-container">
            <a class="menu-logo" routerLink="/dashboard">
              <img src="assets/{{ minimize() ? 'opero-isotype' : 'menu-logo-dark' }}.svg" alt="Logo opero" class="menu-img">
            </a>
            <div class="close-icon-container" (click)="toggleMenu()" (keyup.enter)="toggleMenu()" (keyup.space)="toggleMenu()" tabindex="0" role="button" aria-label="Ícono cerrar menú"></div>
          </div>
          <div class="menu-items">
            @if (session(); as session) {
              @for (route of dashboardRoutes(); track route.path) {
                <a class="item-container" [class.active]="currentDashboardModule()?.startsWith(route.path)" [attr.aria-current]="currentDashboardModule()?.startsWith(route.path) ? 'page' : null" [routerLink]="route.path" [queryParams]="{}" [attr.aria-label]="route.label" (click)="toggleMenu()">
                  <div class="icon {{ route.icon }}"></div>
                  <span class="label">{{ route.label }}</span>
                </a>
              }
            }
          </div>
        </div>
        <div class="bottom-group">
          @if (!minimize()) {
            @if (!quoteTutorialCompleted()) {
              <div class="menu-banner-container">
                <app-menu-banner
                  buttonLabel="Comenzar ahora"
                  buttonHref="/dashboard/tutorial"
                  description="Te mostraremos los elementos que la componen y los botones de acción necesarios para que puedas hacer crecer tu negocio."
                  imageUrl="/assets/images/crypto-currency.webp"
                  title="Creemos juntos tu primera cotización"
                />
              </div>
            } @else if (company()?.alliance; as alliance) {
              <div class="menu-banner-container">
                @if (alliance === 'anwo') {
                  <!-- TODO: add button href -->
                  <app-menu-banner
                    buttonLabel="Conoce tus beneficios"
                    buttonHref=""
                    description="Más descuentos, despacho gratis, caja preferencial y mucho más. ¡Lleva tu negocio al siguiente nivel!"
                    [imageHeight]="160"
                    imageUrl="/assets/images/alianza-anwo.webp"
                    title="¡Ya eres parte de la nueva alianza ANWO CIE!"/>
                } @else if (alliance === 'construmart') {
                  <!-- TODO: add button href -->
                  <app-menu-banner
                    buttonLabel="Conoce tus beneficios"
                    buttonHref=""
                    description="Más descuentos, despacho gratis, caja preferencial y mucho más. ¡Lleva tu negocio al siguiente nivel!"
                    [imageHeight]="160"
                    imageUrl="/assets/images/alianza-construmart.webp"
                    title="¡Ya eres parte de la nueva alianza Construmart!"/>
                } @else if (alliance === 'easy') {
                  <!-- TODO: add button href -->
                  <app-menu-banner
                    buttonLabel="Conoce tus beneficios"
                    buttonHref=""
                    description="Más descuentos, despacho a $1, caja preferencial y mucho más. ¡Lleva tu negocio al siguiente nivel!"
                    [imageHeight]="160"
                    imageUrl="/assets/images/club-easy-pro.webp"
                    title="¡Ya eres parte del Club Easy PRO!"/>
                } @else if (alliance === 'mk') {
                  <app-menu-banner
                    buttonLabel="Ir a MK"
                    buttonHref="https://www.mk.cl/"
                    description="Queremos apoyarte en llevar tu negocio al siguiente nivel. Próximamente informaremos nuevos beneficios."
                    [imageHeight]="160"
                    imageUrl="/assets/images/alianza-mk.webp"
                    title="¡Ya eres parte de la nueva Alianza MK!"/>
                } @else if (alliance === 'sodimac') {
                  <!-- TODO: add button href -->
                  <app-menu-banner
                    buttonLabel="Conoce tus beneficios"
                    buttonHref=""
                    description="Más descuentos, crédito hasta $4MM y atención personalizada. ¡Lleva tu negocio al siguiente nivel!"
                    [imageHeight]="160"
                    imageUrl="/assets/images/circulo-black-sodimac.webp"
                    title="¡Ya eres parte del Circulo Black de SODIMAC!"/>
                }
              </div>
            }
          }
          <div class="menu-actions">
            <div class="minimize-container" (click)="minimizeMenu()" (keyup.enter)="minimizeMenu()" (keyup.space)="minimizeMenu()" tabindex="0" role="button">
              <div class="icon"></div>
              <span class="label">Minimizar</span>
            </div>
            <a class="support-container" href="https://ayuda.opero.cl" target="_blank" rel="noopener noreferrer" aria-label="Centro de ayuda" (click)="toggleMenu()">
              <div class="icon" aria-hidden="true"></div>
              <span class="label">Centro de ayuda</span>
            </a>
            <div class="menu-user-info-container">
              @if (company()?.logoUrl) {
                <img [src]="company()?.logoUrl" [alt]="'Logo de ' + company()?.name" class="menu-company-logo" />
              } @else {
                <svg class="menu-company-logo-fallback" width="44" height="44" viewBox="0 0 44 44">
                  <circle cx="22" cy="22" r="22" fill="#5f616a"></circle>
                  <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" font-family="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif">
                    {{ company()?.name?.charAt(0)?.toUpperCase() }}
                  </text>
                </svg>
              }
              <div class="menu-user-info-text">
                <p class="menu-company-name">{{ company()?.name }}</p>
                <p class="menu-user-name">{{ userName() }}</p>
                @if (company()?.id !== operoCompanyId && user()?.role === 'admin') {
                  <button type="button" class="menu-join-company-button" (click)="joinOperoCompany()">Volver a empresa Opero</button>
                }
              </div>
              <button type="button" id="click-mCR7KSKa" class="menu-options-button" aria-label="Opciones" (click)="openMenu()">
                <img class="icon" src="assets/icons/dots.svg" alt="Ícono tres puntos">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-menu>
</ng-template>
